
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ShareBtnComponent',
    props: {
        showSave: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            showPop: false,
        }
    },
   
    mounted () {
     
    },
    methods: {
        saveClick() {
            this.$emit('save');
        }
    }
})
